import { Buffer } from "buffer";

/**
 * gost89 and parts of jkurwa expect a Node-style global `Buffer`. This module
 * is imported first by `libs/kep/src/index.ts`, before anything reaches jkurwa,
 * so no app has to remember an import order.
 */
export const installBufferGlobal = (): void => {
  const scope = globalThis as typeof globalThis & { Buffer?: typeof Buffer };

  scope.Buffer = scope.Buffer ?? Buffer;
};

installBufferGlobal();
